import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default (reducers) => {
  const persistedReducers = persistReducer(
    {
      key: 'CONSUMIR_API_CONCURSO',
      storage,
      whitelist: ['auth'],
    },
    reducers,
  );
  return persistedReducers;
};
